<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="publisher_list" class="elevation-1 mytable" id="my-table-id" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Publisher Master</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row dense>
                        <v-col cols="12" sm="3" md="3">
                            <v-btn rounded color="success" outlined
                                @click="fnExcelReport('my-table-id', 'Publishers')"><v-icon
                                    color="success">mdi-export</v-icon>Export</v-btn>
                        </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Publisher</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <b>Name</b><v-icon class="pl-1 pb-2" color="error">*</v-icon>
                                                    <v-text-field v-model="editedItem.name" persistent-hint
                                                        :rules="[(v) => !!v || 'required']" outlined dense
                                                        hint="For ex. Vishwakarma Publication,NCERT..."></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" color="primary" @click="save"
                                            :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                </template>
                <template v-slot:item.delete="{ item }">
                    <div>
                        <v-avatar size="25" class="edit-avatar">
                            <v-icon class=" v-icon-size" color="red" @click="deleteItem(item)">mdi-trash-can</v-icon>
                        </v-avatar>
                    </div>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <v-switch inset v-model="item.isactive" :color="item.isactive ? 'success' : 'primary'"
                        @change="toggle(item)"></v-switch>
                </template>
            </v-data-table>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        errorMsg: {
            name: false,
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        headers: [
            {
                text: "Name",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "Status",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
            { text: "Delete", value: "delete", sortable: false },
        ],
        publisher_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            name: "",
            isactive: true,
        },
        defaultItem: {
            id: "",
            name: "",
            isactive: true,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Publisher" : "Edit Publisher";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text =
                tab_text +
                "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text =
                tab_text +
                "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text =
                tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text =
                tab_text + "<table style='border-collapse:collapse;' border='1'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find("th, td").each(function () {
                $(this).css("border", "1px solid black");
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName =
                name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
            const blob = new Blob([tab_text], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
        editItem(item) {
            this.editedIndex = this.publisher_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/BookReview/getPublisher")
                .then((res) => {
                    this.overlay = false;
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.publisher_list = res.data.publisher_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/BookReview/editPublisher", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                //window.alert(res.data.msg)
                                this.onLoad();
                                Object.assign(this.publisher_list[this.editedIndex], this.editedItem);
                            }
                            this.showSnackbar("#4caf50", "Publisher Updated Successfully..."); // show snackbar on success
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/BookReview/savePublisher", this.editedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            //window.alert(res.data.status.code)
                            this.publisher_list.push(this.editedItem);
                            this.showSnackbar("#4caf50", "Publisher Added Successfully..."); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.code == "NA") {
                            //window.alert(res.data.status.code)
                            //alert(res.data.status.message)
                            this.showSnackbar("#b71c1c", "Publisher Already Present!!!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        }, //save()


        deleteItem(item) {

            if (!confirm("Are You Sure You Want To Delete Publisher ...?")) return;
            const formData = {
                id: item.id,

            };

            axios
                .post("/BookReview/deletePublisher", formData)
                .then((res) => {
                    if (res.data.status == "YES") {
                        this.showSnackbar("#4caf50", "Publisher Delete Successfully..."); // show snackbar on success
                        //  this.payment_gateway_details_list = res.data.payment_gateway_details_list;

                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                ;
        },
        isValidated() {
            if (this.editedItem.name) {
                return true;
            } else {
                if (!this.editedItem.name) {
                    this.errorMsg.name = true;
                }

                return false;
            }
        }, // .....end of isValidated()

        toggle(item) {
            const data = {
                section_id: item.id,
                toggle: item.isactive,
            };
            this.overlay = true;
            axios
                .post("/BookReview/togglePublisher", data)
                .then((res) => {
                    this.overlay = false;
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "Publisher Status Changed!"); // show snackbar
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#4caf50", "Something went wrong, Please try again later!"); // show snackbar
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
